import React, { Component } from "react";
import { connect } from "react-redux";
import { BlankTemplate } from "../BlankTemplate";
import { RegisterForm } from "./RegisterForm";
import "./registerPage.scss";

class RegisterPage extends Component {
  render() {
    return (
      <BlankTemplate>
        <div id="registerPage" className="registerPage">
          <div className="rightSide" />
          <div className="leftSide">
            <RegisterForm />
          </div>
        </div>
      </BlankTemplate>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    register: state.registerReducer,
  };
};

const RegisterPageWithRedux = connect(mapStateToProps)(RegisterPage);

export { RegisterPageWithRedux as RegisterPage };



// WEBPACK FOOTER //
// ./src/components/RegisterPage/RegisterPage.jsx